import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PropertiesEditorsService {
  private closeDialogSubject = new Subject<any>();

  closeDialog$ = this.closeDialogSubject.asObservable();
  callCloseDialogSubject() {
    this.closeDialogSubject.next(null);
  }
}
